export { default } from './HotelGeneralInfo';
